export default __webpack_public_path__ + "static/dron-cff0be2cc99487b0030cb8ecb5ccc571.webp";